import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
//API
import { BranchOfficeFetchAPI } from '../../../api/BranchOffices';
import { UsersFetchAPI } from '../../../api/Users';
import { OrdersFetchAPI } from '../../../api/Orders';
import { EventsFetchAPI } from '../../../api/Events';
// External Componets
import moment from 'moment-timezone';
import Select from 'react-select';

//Internal components 
import ReportTable from '../table/ReportTable';
import SuccessAlert from '../../Alerts/SuccessAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { ExcelModuleFechtAPI } from '../../../api/ExcelModule';


const ProductSalesReport = ({ events, setEvents, selectedEventOption, setSelectedEventOption, selectedBranch, setSelectedBranch, selectedBranches, setSelectedBranches }) => {
    //We get the token 
    let token = localStorage.getItem('x-access-token');
    //We get the user data 
    let user = JSON.parse(localStorage.getItem('user'))
    //States 
    const [userBranchoffices, setUserBranchs] = useState([]);
    const [userBusiness, setUserBusiness] = useState({
        id: 0
    });
    const [initialDate, setInitialDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00');
    const [maxDate, setMaxDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00')
    const [data, setReportData] = useState({
        product_sales: []
    });

    const selectedBranchCodes = selectedBranches?.length > 0
        ? selectedBranches.map((b) => b.code)
        : [];

    //The default option of the select input 
    const defaultOption = [{ label: 'Seleccione...', value: 0 }];

    const eventsList = events.map((event) => ({
        label: event.name,
        value: event?.id ?? event.event_id
    }));

    //Event to detect the event selected on search select
    const handleChangeEvents = (option) => {
        //We check if the option is null
        if (option.value === 0) {
            setSelectedEventOption(null);
        } else {
            setSelectedEventOption(option);
        }
    }

    //Function to get events depending of the branch selected
    const getEvents = async () => {
        let response;
        try {
            if (selectedBranches?.length === 1) {
                response = await EventsFetchAPI.getEventsByBranchoffice(
                    selectedBranches[0].branchoffice_id || selectedBranches[0].id,
                    token
                );
            } else {
                response = await EventsFetchAPI.getEventsByBusiness(userBusiness.id, token);
            }

            setEvents(response.data.events);
        } catch (err) {
            console.log(err);
            setEvents([]);
        }
    };

    //Function to get the report of the branch office 
    const getReport = async (dateMin, dateMax) => {
        try {
            let event = selectedEventOption !== null && selectedEventOption.value !== 0 && selectedEventOption.value !== undefined ? selectedEventOption.value : undefined;

            //We show a loading alert 
            LoadingAlert();
            const sales = await OrdersFetchAPI.getProductSalesReport(
                dateMin,
                dateMax,
                selectedBranch.id,
                0,
                token,
                event,
                selectedBranchCodes
            );
            //We set the info 
            setReportData({
                product_sales: sales.data.total_product_sales,
            });

            //We show a success alert
            SuccessAlert();
        } catch (err) {
            //We show a error alert 
            ErrorAlert('No tiene información')
            console.log(err)
        }
    }


    //Hook to load the initial data 
    useEffect(() => {
        //We set the branchoffices of the user 
        setUserBranchs(user.branchoffices);
        //We set the business user 
        setUserBusiness(user.business);
    }, []);

    //Hook to load the events depending the selection of branch 
    useEffect(() => {
        if (userBusiness?.id) {
            getEvents();
        }
    }, [selectedBranches, userBusiness]);

    //Function to download the product sales report
    const downloadProductSalesReport = async () => {
        let error = false
        try {
            let event = selectedEventOption !== null && selectedEventOption.value !== 0 && selectedEventOption.value !== undefined ? selectedEventOption.value : undefined;
            await ExcelModuleFechtAPI.downloadProductSalesReport(
                token,
                initialDate,
                maxDate,
                selectedBranch.id,
                userBusiness.id,
                event,
                selectedBranchCodes
            );
        } catch (err) {
            console.log(err)
            error = true
        }

        //We show a error alert
        if (error) {
            ErrorAlert('No se pudo descargar el reporte', 'Error de descarga', 'error');
        }
    }

    return (
        <div>
            <h4>Filtros</h4>
            <div className="row gx-3 gy-2 align-items-center bg-white p-2 my-3 border-sp border shadow-sm">

                <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                        <label htmlFor="input_from">Desde</label>
                        <input type="date" name="initialDate" onChange={e => setInitialDate(e.target.value + "T00:00:00.000+00:00")} className="control mt-3" />
                    </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                    <div className="form-group">
                        <label htmlFor="input_from">Hasta</label>
                        <input type="date" name="finishDate" onChange={e => setMaxDate(e.target.value + "T23:59:59.000+00:00")} className="control mt-3" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-3">
                    <label htmlFor="input_form" className="fw-bold">Eventos (opcional)</label>
                    <Select
                        className='w-100'
                        value={selectedEventOption}
                        options={[defaultOption[0], ...eventsList]}
                        onChange={handleChangeEvents}
                    />
                </div>
                <div className=" d-flex justify-content-center justify-content-sm-end mb-3">
                    <button type="button" onClick={e => getReport(initialDate, maxDate)} className="btn btn-success px-5">Aceptar</button>
                </div>
            </div>

            <div className="d-flex justify-content-between mt-3">
                <h5 className="mt-4">Reporte de ventas por metodo de pago </h5>
                <div className="mt-3 mb-2">
                    <button onClick={() => downloadProductSalesReport()} className="btn btn-success">
                        <i className="fa-solid fa-file-excel"></i>
                        Descargar Excel</button>
                </div>

            </div>

            {/**Table */}
            <ReportTable
                table_name="Tabla de ventas por producto"
                table_headers={["Nombre del producto", "Unidades vendidas", "Total vendido"]}
                table_type="products_report"
                table_data={data.product_sales} />

        </div>


    );
}

export default ProductSalesReport;
